import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { __rest } from '../_virtual/_tslib.js';
import { warn } from '../util/console.js';
import { split2 } from '../util/misc.js';
import { GenericRemediator } from './remediators/GenericRemediator/GenericRemediator.js';
import { IdxFeature } from './types/api.js';
var ctx = {
  remediators: {},
  getFlowSpecification: function getFlowSpecification(_oktaAuth) {
    var _flow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
    return {
      remediators: {}
    };
  }
};
function setRemediatorsCtx(newCtx) {
  Object.assign(ctx, newCtx);
}
function getFlowSpecification(oktaAuth) {
  var flow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  return ctx.getFlowSpecification(oktaAuth, flow);
}
function isTerminalResponse(idxResponse) {
  var neededToProceed = idxResponse.neededToProceed,
    interactionCode = idxResponse.interactionCode;
  return !neededToProceed.length && !interactionCode;
}
function canSkipFn(idxResponse) {
  return idxResponse.neededToProceed.some(function (_ref) {
    var name = _ref.name;
    return name === 'skip';
  });
}
function canResendFn(idxResponse) {
  return Object.keys(idxResponse.actions).some(function (actionName) {
    return actionName.includes('resend');
  });
}
function getMessagesFromIdxRemediationValue(value) {
  if (!value || !Array.isArray(value)) {
    return;
  }
  return value.reduce(function (messages, value) {
    if (value.messages) {
      messages = [].concat(_toConsumableArray(messages), _toConsumableArray(value.messages.value));
    }
    if (value.form) {
      var messagesFromForm = getMessagesFromIdxRemediationValue(value.form.value) || [];
      messages = [].concat(_toConsumableArray(messages), _toConsumableArray(messagesFromForm));
    }
    if (value.options) {
      var optionValues = [];
      value.options.forEach(function (option) {
        if (!option.value || typeof option.value === 'string') {
          return;
        }
        optionValues = [].concat(_toConsumableArray(optionValues), [option.value]);
      });
      var messagesFromOptions = getMessagesFromIdxRemediationValue(optionValues) || [];
      messages = [].concat(_toConsumableArray(messages), _toConsumableArray(messagesFromOptions));
    }
    return messages;
  }, []);
}
function getMessagesFromResponse(idxResponse, options) {
  var _a;
  var messages = [];
  var rawIdxState = idxResponse.rawIdxState,
    neededToProceed = idxResponse.neededToProceed;
  var globalMessages = (_a = rawIdxState.messages) === null || _a === void 0 ? void 0 : _a.value.map(function (message) {
    return message;
  });
  if (globalMessages) {
    messages = [].concat(_toConsumableArray(messages), _toConsumableArray(globalMessages));
  }
  if (!options.useGenericRemediator) {
    var _iterator = _createForOfIteratorHelper(neededToProceed),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var remediation = _step.value;
        var fieldMessages = getMessagesFromIdxRemediationValue(remediation.value);
        if (fieldMessages) {
          messages = [].concat(_toConsumableArray(messages), _toConsumableArray(fieldMessages));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  var seen = {};
  messages = messages.reduce(function (filtered, message) {
    var _a;
    var key = (_a = message.i18n) === null || _a === void 0 ? void 0 : _a.key;
    if (key && seen[key] && message.message === seen[key].message) {
      return filtered;
    }
    seen[key] = message;
    filtered = [].concat(_toConsumableArray(filtered), [message]);
    return filtered;
  }, []);
  return messages;
}
function getEnabledFeatures(idxResponse) {
  var res = [];
  var actions = idxResponse.actions,
    neededToProceed = idxResponse.neededToProceed;
  if (actions['currentAuthenticator-recover']) {
    res.push(IdxFeature.PASSWORD_RECOVERY);
  }
  if (neededToProceed.some(function (_ref2) {
    var name = _ref2.name;
    return name === 'select-enroll-profile';
  })) {
    res.push(IdxFeature.REGISTRATION);
  }
  if (neededToProceed.some(function (_ref3) {
    var name = _ref3.name;
    return name === 'redirect-idp';
  })) {
    res.push(IdxFeature.SOCIAL_IDP);
  }
  if (neededToProceed.some(function (_ref4) {
    var name = _ref4.name;
    return name === 'unlock-account';
  })) {
    res.push(IdxFeature.ACCOUNT_UNLOCK);
  }
  return res;
}
function getAvailableSteps(authClient, idxResponse, useGenericRemediator) {
  var _a;
  var res = [];
  var remediatorMap = Object.values(ctx.remediators).reduce(function (map, remediatorClass) {
    if (remediatorClass.remediationName) {
      map[remediatorClass.remediationName] = remediatorClass;
    }
    return map;
  }, {});
  var _iterator2 = _createForOfIteratorHelper(idxResponse.neededToProceed),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var remediation = _step2.value;
      var T = getRemediatorClass(remediation, {
        useGenericRemediator: useGenericRemediator,
        remediators: remediatorMap
      });
      if (T) {
        var remediator = new T(remediation);
        res.push(remediator.getNextStep(authClient, idxResponse.context));
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var _loop = function _loop() {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 1),
      name = _Object$entries$_i[0];
    var stepObj = {
      name: name,
      action: function () {
        var _action = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", authClient.idx.proceed({
                  actions: [{
                    name: name,
                    params: params
                  }]
                }));
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function action(_x) {
          return _action.apply(this, arguments);
        }
        return action;
      }()
    };
    if (name.startsWith('currentAuthenticator')) {
      var _split = split2(name, '-'),
        _split2 = _slicedToArray(_split, 2),
        part1 = _split2[0],
        part2 = _split2[1];
      var actionObj = idxResponse.rawIdxState[part1].value[part2];
      var rest = __rest(actionObj, ["href", "method", "rel", "accepts", "produces"]);
      var value = (_a = actionObj.value) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
        return item.name !== 'stateHandle';
      });
      stepObj = Object.assign(Object.assign(Object.assign({}, rest), value && {
        value: value
      }), stepObj);
    }
    res.push(stepObj);
  };
  for (var _i = 0, _Object$entries = Object.entries(idxResponse.actions || {}); _i < _Object$entries.length; _i++) {
    _loop();
  }
  return res;
}
function filterValuesForRemediation(idxResponse, remediationName, values) {
  var remediations = idxResponse.neededToProceed || [];
  var remediation = remediations.find(function (r) {
    return r.name === remediationName;
  });
  if (!remediation) {
    warn("filterValuesForRemediation: \"".concat(remediationName, "\" did not match any remediations"));
    return values;
  }
  var valuesForRemediation = remediation.value.reduce(function (res, entry) {
    var name = entry.name,
      value = entry.value;
    if (name === 'stateHandle') {
      res[name] = value;
    } else {
      res[name] = values[name];
    }
    return res;
  }, {});
  return valuesForRemediation;
}
function getRemediatorClass(remediation, options) {
  var useGenericRemediator = options.useGenericRemediator,
    remediators = options.remediators;
  if (!remediation) {
    return undefined;
  }
  if (useGenericRemediator) {
    return GenericRemediator;
  }
  return remediators[remediation.name];
}
function getRemediator(idxResponse, values, options) {
  var remediators = options.remediators;
  var useGenericRemediator = options.useGenericRemediator;
  var idxRemediations = idxResponse.neededToProceed,
    context = idxResponse.context;
  var remediator;
  if (options.step) {
    var remediation = idxRemediations.find(function (_ref5) {
      var name = _ref5.name;
      return name === options.step;
    });
    if (remediation) {
      var T = getRemediatorClass(remediation, options);
      return T ? new T(remediation, values, options) : undefined;
    } else {
      warn("step \"".concat(options.step, "\" did not match any remediations"));
      return;
    }
  }
  var remediatorCandidates = [];
  if (useGenericRemediator) {
    remediatorCandidates.push(new GenericRemediator(idxRemediations[0], values, options));
  } else {
    var _iterator3 = _createForOfIteratorHelper(idxRemediations),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _remediation = _step3.value;
        var isRemeditionInFlow = Object.keys(remediators).includes(_remediation.name);
        if (!isRemeditionInFlow) {
          continue;
        }
        var _T = getRemediatorClass(_remediation, options);
        remediator = new _T(_remediation, values, options);
        if (remediator.canRemediate(context)) {
          return remediator;
        }
        remediatorCandidates.push(remediator);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return remediatorCandidates[0];
}
function getNextStep(authClient, remediator, idxResponse) {
  var nextStep = remediator.getNextStep(authClient, idxResponse.context);
  var canSkip = canSkipFn(idxResponse);
  var canResend = canResendFn(idxResponse);
  return Object.assign(Object.assign(Object.assign({}, nextStep), canSkip && {
    canSkip: canSkip
  }), canResend && {
    canResend: canResend
  });
}
function handleFailedResponse(authClient, idxResponse) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var terminal = isTerminalResponse(idxResponse);
  var messages = getMessagesFromResponse(idxResponse, options);
  if (terminal) {
    return {
      idxResponse: idxResponse,
      terminal: terminal,
      messages: messages
    };
  } else {
    var remediator = getRemediator(idxResponse, {}, options);
    var nextStep = remediator && getNextStep(authClient, remediator, idxResponse);
    return Object.assign({
      idxResponse: idxResponse,
      messages: messages
    }, nextStep && {
      nextStep: nextStep
    });
  }
}
export { canResendFn, canSkipFn, filterValuesForRemediation, getAvailableSteps, getEnabledFeatures, getFlowSpecification, getMessagesFromIdxRemediationValue, getMessagesFromResponse, getNextStep, getRemediator, handleFailedResponse, isTerminalResponse, setRemediatorsCtx };